module.exports = __webpack_public_path__ + "static/media/wheel.3dcc3027.png";